<template>
  <form v-on:submit.prevent="processLoginUser" class="login-form">
      <div class="login-form-field">
        <div class="icon">
            <img src="../assets/user-regular.svg" alt="">
        </div>
        <input class="input-text" type="text" placeholder="Username" id="inputUser" v-model="user.username">
      </div>
      <div class="login-form-field">
        <div class="icon">
            <img src="../assets/lock-solid.svg" alt="">
        </div>
        <input class="input-text" type="password" placeholder="Password" id="inputPassword" v-model="user.password">
      </div>
    <button class="button" type="submit">Iniciar Sesión</button>
  </form>
</template>

<script>
export default {
    name:"Login",
    data(){
        return{
            user:{
                username: '',
                password: '',
            },
        }
    },
    methods: {
        processLoginUser(){
            this.$store.dispatch("logInUser", this.user);
        },
    },
}
</script>

<style lang="scss">
.login-form{
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: auto;
    margin-top: 2.5em;

    &-field{
        margin-bottom: 16px;
        width: 100%;
        position: relative;

        & .icon{
            position: absolute;
            background: #a3a1a1;
            left:0;
            top: 0;
            display: flex;
            align-items: center;
            width: 40px;
            height: 40px;
            justify-content: center;
            border-radius: .5em;
            border-bottom-right-radius: 20px;
            border-top-right-radius: 20px;

            img{
                width: 33%;
                filter: invert(100%);
            }
        }
        & .icon:after{
            content: "";
            display: block;
            width: 0;
            height: 0;
            border: 12px solid transparent;
            border-left: 12px solid #a3a1a1;
            position: absolute;
            top: 8px;
            right: -20px;
        }
        input {
            text-align: center;
            height: 40px;
            color: #aaa;
            font-weight: bold;
            letter-spacing: .5px;
            font-size: 1em;
        }
        input::placeholder{
            color:#a3a1a1;
        }
        input:focus::placeholder{
            color: transparent;
        }
    }
}
@media (min-width: 600px){
    .login-form{
        width: 70%;
    }
}
@media (min-width: 950px){
    .login-form{
        width: 55%;
    }
}
@media (min-width: 1200px){
    .login-form{
        width: 30%;
    }
}
</style>